import { getCashDay, listCashHolders } from "../../../services/cashBookApi";
import { getCashBook } from "../../../services/karkhanaApi";
import { istToday } from "./money";

/**
 * Cash in hand for the screens outside the cash book (Pay page card, More tiles). With the Cash book
 * add-on the figures come from the cash book's own reads (/day, /holders: carry-forward, confirmed
 * transfers, paid on unchecked sheets), the same numbers as the नकद tab (V1_SPEC D40). Without it,
 * today's cash book totals, unchanged. null = not known (the screen shows no number).
 */
export type SupervisorCash = { id: string; name: string; cashInHand: string | number | null };

export const myCashInHand = async (cashbookOn: boolean): Promise<string | number | null> => {
  try {
    if (cashbookOn) {
      const res = await getCashDay(istToday());
      return res?.success ? res.data?.cash?.inHand ?? null : null;
    }
    const res: any = await getCashBook();
    return res?.success ? res.data?.cashInHand ?? null : null;
  } catch {
    return null;
  }
};

export const supervisorsCash = async (cashbookOn: boolean): Promise<SupervisorCash[] | null> => {
  try {
    if (cashbookOn) {
      const res = await listCashHolders();
      return res?.success ? (res.data?.holders || []).map((h) => ({ id: h.userId, name: h.name, cashInHand: h.inHand ?? null })) : null;
    }
    const res: any = await getCashBook();
    return res?.success ? (res.data?.supervisors || []).map((s: any) => ({ id: s.id, name: s.name, cashInHand: s.cashInHand ?? null })) : null;
  } catch {
    return null;
  }
};
